import React from 'react';
import { Dropdown, Menu, Tag } from 'antd';
import { MoreOutlined, RightSquareOutlined } from '@ant-design/icons';
import moment from 'moment';
import type { Report } from '../../types';
import { getStatusStyle } from './statusStyles';

interface PriorReportsProps {
  reports: Report[];
  isSignedOff: boolean;
  onLoadAsTemplate: (report: Report) => void;
}

const PriorReports: React.FC<PriorReportsProps> = ({ reports, isSignedOff, onLoadAsTemplate }) => {
  if (!reports.length) {
    return <div className="no-content-message">No prior reports available</div>;
  }

  return (
    <>
      {reports.map(record => {
        const menu = (
          <Menu>
            <Menu.Item key="view" icon={<RightSquareOutlined />} onClick={() => onLoadAsTemplate(record)} disabled={isSignedOff}>
              Load as Template
            </Menu.Item>
          </Menu>
        );

        return (
          <div key={record.pr_id} className="report-list-item">
            <div className="report-item-line-1">
              <span>Created by {record.pr_reported_by}</span>
              <Dropdown overlay={menu} trigger={['click']} disabled={isSignedOff}>
                <MoreOutlined style={{ fontSize: '1rem', cursor: isSignedOff ? 'not-allowed' : 'pointer', color: isSignedOff ? '#d9d9d9' : 'inherit' }} />
              </Dropdown>
            </div>
            <div className="report-item-line-2">
              {moment(record.createdAt).format('DD-MM-YYYY hh:mm A')}
            </div>
            <div className="report-item-line-3">
              <Tag style={getStatusStyle(record.pr_status)}>
                {record.pr_status?.replaceAll('_', ' ')}
              </Tag>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default PriorReports;
